import { render, staticRenderFns } from "./WapOurGoodness.vue?vue&type=template&id=15aeb058&scoped=true&"
var script = {}
import style0 from "./WapOurGoodness.vue?vue&type=style&index=0&id=15aeb058&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aeb058",
  null
  
)

export default component.exports